var _circle, _circle2, _circle3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJustLookingAround(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 637,
    viewBox: "0 -59 637 637",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 204.185,
    stroke: "#151C2B",
    strokeWidth: 28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 304.5,
    stroke: "#151C2B",
    strokeWidth: 28
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 112.854,
    fill: "#212C42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.5 258C313.773 258 320.5 251.273 320.5 243C320.5 240.305 319.586 237.773 318.531 235.594C319.188 235.523 319.844 235.5 320.5 235.5C332.922 235.5 343 245.367 343 258C343 270.422 332.922 280.5 320.5 280.5C307.867 280.5 298 270.422 298 258C298 257.344 298.023 256.688 298.094 256.031C300.273 257.086 302.805 258 305.5 258Z",
    fill: "#719CF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M275.364 224.391C286.398 214.134 301.563 205.5 320.5 205.5C339.438 205.5 354.602 214.134 365.641 224.391C376.609 234.562 383.945 246.539 387.414 255.117C388.188 256.969 388.188 259.031 387.414 260.883C383.945 269.25 376.609 281.227 365.641 291.609C354.602 301.875 339.438 310.5 320.5 310.5C301.563 310.5 286.398 301.875 275.364 291.609C264.395 281.227 257.064 269.25 253.577 260.883C252.808 259.031 252.808 256.969 253.577 255.117C257.064 246.539 264.395 234.562 275.364 224.391ZM320.5 291.75C339.133 291.75 354.25 276.633 354.25 258C354.25 239.367 339.133 224.25 320.5 224.25C301.867 224.25 286.75 239.367 286.75 258C286.75 276.633 301.867 291.75 320.5 291.75Z",
    fill: "#719CF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustLookingAround);
export default __webpack_public_path__ + "static/media/just-looking-around.9139581d79d80da618da5586a90aef81.svg";
export { ForwardRef as ReactComponent };